
export enum TransferStatus {
    CREATED = "CREATED",
    TO_TRANSFER = "TO_TRANSFER",
    TRANSFERRED_TO_PRODUCER = "TRANSFERRED_TO_PRODUCER",
    TRANSFERRED_TO_OPERATOR = "TRANSFERRED_TO_OPERATOR"
}